import { Injectable } from '@angular/core';

import { AuthenticationService } from '../services/authentication/authentication.service';

@Injectable()
export class LoginModuleGuard  {
    constructor(private authenticationService: AuthenticationService) {}

    canActivate() {
        if (this.authenticationService.isLoggedIn()) {
            return false;
        }
        return true;
    }
}
